import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { filter } from 'fuzzaldrin'
import _ from 'underscore'
var date = {
    format: require('date-fns/format')
}
import { Modal, Button, Alert } from 'react-bootstrap'
import {CircularProgressbar} from 'react-circular-progressbar'
import { DashboardModal, StatusBar } from '@uppy/react'
import Tippy from '@tippy.js/react'
import Loader from '../common/components/notifications/Loader'
import LazyPreview from './lazy-preview'
import { BgIcon, BgImage } from './components'
import AssetInfoTable from '../misc-assets/components/asset-info-table'

import LinkUpload from '../routes/media/LinkUpload'
import util from './util'
import { Link } from 'react-router-dom'
import RestrictedComponent from '../lib/components/form/RestrictedComponent'
import schema from '../routes/permissions/schema'

const humanizeFilesize = util.humanizeFilesize
const memo = util.memo

function isTypeResolving (type, props) {
    var { requests } = props.assets
    return _.findWhere(requests.resolving, { type })
}
var isEditResolving = props => isTypeResolving('edit', props)

var getFilteredAssets = memo(function ({ fileType, assets }) {
    return fileType === 'all' ?
        assets :
        assets.filter(asset => (fileType === 'transcoding' ?
            asset.currentStatus === 'transcoding' :
            asset.type === fileType))
})

var searchNames = memo(function ({ query, assets }) {
    return filter(assets, query, { key: 'name' })
})

function getFilterString ({ assets }) {
    var { sortBy, order } = assets.data
    if (sortBy === 'name') return (order === 'asc' ?
        'ascending' :
        'descending') + ' by name'
    if (sortBy === 'dateCreated') return (order === 'asc' ?
        'oldest' : 'newest') + ' first'
}

function getError (assets) {
    return assets.requests.error
}

function getErrorMessage (assets) {
    try {
        return assets.requests.error.error.message
    } catch (err) {
        return
    }
}

const MiscAssetsView = props => {
    const [showUploadModal, setShowUploadModal] = useState(false)
    const [showNotice, setShowNotice] = useState(false)
    if (
        document.getElementsByClassName("uppy-Dashboard-innerWrap").length
    ) {
        const innerDashboards = document.getElementsByClassName(
            "uppy-Dashboard-innerWrap"
        );
        Array.prototype.forEach.call(innerDashboards, (uppyEl) => {
            if (
                false && // @todo when linked assets are available for global assets remove this line
                !Array.prototype.some.call(uppyEl.children, function (
                    child
                ) {
                    return child.id === "link-asset-upload";
                }) &&
                uppyEl.children.length < 10
            ) {
                ReactDOM.render(
                    <LinkUpload
                        clientID={props.credentials.clientID}
                        eventID="MISC"
                        uppy={props.uppy}
                    />,
                    uppyEl
                );
            }
        });
    }
    
    const toggleUpload = (ev) => {
        setShowUploadModal(prev => !prev)
    }

    const handleNoticeDismiss = () => {
        setShowNotice(false)
    }

    var sortedAssets = getFilteredAssets({
        fileType: props.fileTypeFilter,
        assets: props.assets.data.sorted
    })
    sortedAssets = props.search ?
        searchNames({ assets: sortedAssets, query: props.search }) :
        sortedAssets

    var { isResolving } = props.assets.requests
    isResolving = isResolving && !props.assets.hasFetched

    if (isResolving) return <div className="misc-assets-view">
        <Loader />
    </div>

    return <div className="misc-assets-view">
        <DashboardModal uppy={props.uppy}
            plugins={[]}
            open={showUploadModal}
            onRequestClose={toggleUpload}
            closeModalOnClickOutside={true}
            showProgressDetails={true}
            hideUploadButton={false}
            hideCancelButton={false}
            hideProgressAfterFinish={false}
            proudlyDisplayPoweredByUppy={false}
        />

        <Modal show={!!getError(props.assets)}
            onHide={props.onHideErrorModal}
        >
            <Modal.Header closeButton />
            <Modal.Body className="alert-danger">
                {getErrorMessage(props.assets) || 'Network error'}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHideErrorModal}>Close</Button>
            </Modal.Footer>
        </Modal>

        <div className="misc-assets-header">
            {(showNotice) ?
            <Alert bsStyle="warning" onDismiss={handleNoticeDismiss}>
                <h4>Global media library is not intended for event based media that you will publish as a final product.</h4>
                <p>This library is used for re-usable content to assign to events, OTT and Ad Campaigns</p>
                <p>If your intent is to upload a video for publication, <Link to="/events/create">create an event</Link> first then upload your video from the assets tab in the new event</p>
            </Alert>: null}
            <div className="misc-assets-header-controls">
                <div className="misc-assets-filter">
                    <div className="filter-control" title="Filter">
                        <label htmlFor="asset-type-filter">
                            <i className="fa fa-filter" aria-hidden="true" />
                        </label>
                        <select value={props.fileTypeFilter} name="type-filter"
                            id="asset-type-filter" onChange={props.onFilterChange}
                        >
                            <option value="all">All files</option>
                            <option value="image">Image</option>
                            <option value="document">Document</option>
                            <option value="video">Video</option>
                            <option value="transcoding">Processing</option>
                        </select>
                    </div>

                    <div className="filter-control">
                        <label>
                            <button className="inv-btn-icon"
                                onClick={props.onSortOrderChange}
                            >
                                {props.assets.data.order === 'asc' ?
                                    <i className="fa fa-sort-amount-asc"
                                        aria-hidden="true"
                                        title="ascending" /> :
                                    <i className="fa fa-sort-amount-desc"
                                        aria-hidden="true"
                                        title="descending" />
                                }
                            </button>
                        </label>
                        <select name="sort-by" id="asset-sort"
                            value={props.assets.data.sortBy}
                            onChange={props.onSortChange}
                        >
                            <option value="name">Name</option>
                            <option value="dateCreated">Date</option>
                        </select>
                    </div>

                    <div className="filter-control">
                        <label>
                            <i className="fa fa-search" aria-hidden="true" />
                        </label>
                        <input type="text" onChange={props.onSearchChange}
                            placeholder="Asset name..." />
                    </div>

                </div>

                <div className="misc-assets-page-controls">
                    <StatusBar
                        uppy={props.uppy}
                        hideUploadButton={true}
                        hideAfterFinish={true}
                        showProgressDetails={true}
                    />

                    <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_GLOBAL_MEDIA.CREATE}>
                        <button className="btn btn-primary"
                            onClick={toggleUpload}
                        >
                            <i className="fa fa-plus"/> New asset
                        </button>
                    </RestrictedComponent>
                </div>
            </div>

            <div className="results-count">
                <span>
                    {'Viewing ' + sortedAssets.length + ' asset' +
                        (sortedAssets.length === 1 ? ', ' : 's, ') +
                        getFilterString(props)}
                </span>
            </div>
        </div>


        <AssetModal onCloseModal={props.onCloseModal}
            viewingAssetDetails={props.viewingAssetDetails} />

        <AssetsList assets={sortedAssets}
            isEditResolving={isEditResolving(props)}
            isDeleteResolving={isTypeResolving('delete', props)}
            onEdit={props.onEdit}
            onCancelEdit={props.onCancelEdit}
            onSubmitEdit={props.onSubmitEdit}
            onDelete={props.onDelete}
            onConfirmDelete={props.onConfirmDelete}
            onCancelDelete={props.onCancelDelete}
            onViewDetails={props.onViewDetails}
            pendingDelete={props.pendingDelete}
            editingAsset={props.editingAsset}
            onEditChange={props.onEditChange}
            pendingEdits={props.pendingEdits}
        />

    </div>
}

const AssetModal = props => {
    var asset = props.viewingAssetDetails
    if (!asset) return null

    return <Modal show={!!asset} onHide={props.onCloseModal}
        bsSize="large"
    >
        <Modal.Header closeButton>
            <Modal.Title>{asset.name}</Modal.Title>
        </Modal.Header>

        <Modal.Body className="misc-asset-details">
            <AssetInfoTable asset={asset} />
        </Modal.Body>
    </Modal>
}

export default MiscAssetsView

function getEventHandlers (props) {
    return _.pick(props, 'onEdit', 'onDelete', 'onViewDetails',
        'onConfirmDelete', 'onCancelDelete', 'onCancelEdit', 'onEditChange',
        'onSubmitEdit')
}

class AssetsList extends React.PureComponent {
    constructor (props) {
        super(props)
    }

    render () {
        var { props } = this

        return <div className="misc-assets-list">
            {this.props.assets.map(function (asset, i) {
                var isPendingDelete = props.pendingDelete &&
                    (props.pendingDelete.assetID === asset.assetID)

                var isPendingEdit = (props.editingAsset &&
                    props.editingAsset.assetID === asset.assetID)

                return <Asset asset={asset} key={asset.assetID}
                    isPendingDelete={isPendingDelete}
                    isPendingEdit={isPendingEdit}
                    isEditResolving={props.isEditResolving && isPendingEdit}
                    isDeleteResolving={props.isDeleteResolving &&
                        isPendingDelete}
                    pendingEdits={isPendingEdit ? props.pendingEdits : null}
                    {...getEventHandlers(props)} />
            })}
        </div>
    }
}

class Asset extends React.PureComponent {
    constructor (props) {
        super(props)
        this.edit = this.edit.bind(this)
        this.cancelEdit = this.cancelEdit.bind(this)
        this.submitEdit = this.submitEdit.bind(this)
        this.nameChange = this.nameChange.bind(this)
        this.delete = this.delete.bind(this)
        this.viewDetails = this.viewDetails.bind(this)
        this.confirmDelete = this.confirmDelete.bind(this)
        this.cancelDelete = this.cancelDelete.bind(this)
    }

    confirmDelete (ev) {
        ev.preventDefault()
        this.props.onConfirmDelete(this.props.asset)
    }

    cancelDelete (ev) {
        ev.preventDefault()
        this.props.onCancelDelete(this.props.asset)
    }

    delete (ev) {
        ev.preventDefault()
        this.props.onDelete(this.props.asset)
    }

    edit (ev) {
        ev.preventDefault()
        this.props.onEdit(this.props.asset)
    }

    cancelEdit (ev) {
        ev.preventDefault()
        this.props.onCancelEdit(this.props.asset)
    }

    submitEdit (ev) {
        ev.preventDefault()
        this.props.onSubmitEdit(this.props.asset)
    }

    viewDetails (ev) {
        ev.preventDefault()
        this.props.onViewDetails(this.props.asset)
    }

    nameChange (ev) {
        this.props.onEditChange({ name: ev.target.value })
    }

    render () {
        var { asset, isPendingEdit, pendingEdits } = this.props

        var thumb = (<BgIcon>
            <i className="far fa-file" aria-hidden="true" />
        </BgIcon>)
        if (asset.type === 'image') {
            thumb = (<a href={asset.fileUrl} target="_blank">
                <BgImage src={asset.fileUrl} />
            </a>)
        }
        if (asset.type === 'video') thumb = <PreviewPlayer asset={asset} />
        if (asset.type === 'document') {
            thumb = (<a href={asset.fileUrl} target="_blank">
                <BgIcon>
                    <i className="far fa-file-text" aria-hidden="true" />
                </BgIcon>
            </a>)
        }
        return <Card className={'inv-misc-asset ' + asset.currentStatus}>
            <Card.Media className="misc-asset-thumb">
                {thumb}
            </Card.Media>

            <Card.Body>
                <div className="card-body-content">
                    {asset.currentStatus === 'transcoding' ?
                        <div className="progress-wrapper"><CircularProgressbar
                            percentage={asset.transcodeProgress}
                            text={asset.transcodeProgress + '%'}
                        /></div> :
                        null
                    }

                    <div className="card-text-content">
                        <Card.Title className="misc-asset-head">
                            <AssetTitle asset={asset}
                                isPendingEdit={isPendingEdit}
                                onChange={this.nameChange}
                                value={(pendingEdits || {}).name || ''}
                            />
                        </Card.Title>

                        <Card.Detail>
                            <StatusIcon asset={asset} />
                            <AssetDetails asset={asset} />
                        </Card.Detail>
                    </div>
                </div>

                {_createActions.call(this, this.props)}
            </Card.Body>
        </Card>
    }
}

function AssetDetails ({ asset }) {
    if (asset.type === 'upload') {
        return <span>Uploading</span>
    }

    if (asset.currentStatus === 'transcoding') {
        return <span>Processing</span>
    }

    var longDate = date.format(asset.dateCreated, 'MMM DD, YYYY, h:mm:ss A')
    return [<Tippy key={0} content={longDate}>
        <span>
            {date.format(asset.dateCreated, 'MM-DD-YYYY')}
        </span>
    </Tippy>,
    <span key={1}>{humanizeFilesize(asset.fileSize)}</span>,
    asset.type === 'video' ?
        <span key={2}>{asset.totalRunTime}</span> :
        null
    ]
}

function AssetTitle ({ asset, isPendingEdit, value, onChange }) {
    if (!isPendingEdit) return <Tippy content={asset.name} placement="top"
        distance={-20}
    >
        <span>{asset.name}</span>
    </Tippy>
    return <input type="text" value={value} onChange={onChange} autoFocus />
}

function _createActions (props) {
    var { asset, isEditResolving, isDeleteResolving } = props

    if (props.isPendingDelete) {
        return <Card.Actions className="misc-asset-actions">
            <Button onClick={this.cancelDelete} disabled={isDeleteResolving}>
                Cancel
            </Button>

            <Button bsStyle="danger" onClick={this.confirmDelete}
                disabled={isDeleteResolving}
            >
                {isDeleteResolving ?
                    <i className="fa fa-circle-notch fa-spin fa-fw" /> :
                    <i className="fa fa-trash-can" aria-hidden="true" />
                } Delete
            </Button>
        </Card.Actions>
    }

    if (props.isPendingEdit) {
        return <Card.Actions className="misc-asset-actions">
            <Button onClick={this.cancelEdit} disabled={isEditResolving}>
                Cancel
            </Button>

            <Button bsStyle="primary" onClick={this.submitEdit}
                disabled={isEditResolving ||
                    (props.pendingEdits || {}).name === props.asset.name}
            >
                {isEditResolving ?
                    <i className="fa fa-circle-notch fa-spin fa-fw" /> :
                    <i className="fa fa-check" aria-hidden="true" />
                } Save
            </Button>
        </Card.Actions>
    }

    var disabled = asset.type === 'upload' || asset.currentStatus ===
        'transcoding'

    return <Card.Actions className="misc-asset-actions">
        <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_GLOBAL_MEDIA.DELETE}>
            <ButtonIcon title="Delete" onClick={this.delete} disabled={disabled}>
                <i className="fa fa-trash-can" aria-hidden="true" />
            </ButtonIcon>
        </RestrictedComponent>

        <ButtonIcon title="More info" onClick={this.viewDetails}
            disabled={disabled}
        >
            <i className="fa fa-info-circle" aria-hidden="true" />
        </ButtonIcon>

        <LinkIcon href={asset.fileUrl} download={true} disabled={disabled}
            className={disabled ? 'disabled' : ''} title="Download">
            <i className="fa fa-download" aria-hidden="true" />
        </LinkIcon>

        <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_GLOBAL_MEDIA.UPDATE}>
            <ButtonIcon title="Edit" onClick={this.edit} disabled={disabled}>
                <i className="fa fa-pencil" aria-hidden="true" />
            </ButtonIcon>
        </RestrictedComponent>
    </Card.Actions>
}

function LinkIcon (props) {
    return <a {...props} className={combineClasses('inv-link-icon', props)}
        target="_blank"
    >
        {props.children}
    </a>
}

class PreviewPlayer extends React.PureComponent {
    constructor (props) {
        super(props)
    }

    render () {
        var { props } = this
        var { asset } = props

        // if preview is not possible, show the icon & gray background
        // if you can preview, show the play button

        return <div className="inv-preview-player">
            {canPreview(asset) ?
                <LazyPreview asset={asset} /> :
                <NoPreview asset={asset} />
            }
        </div>
    }
}

function NoPreview ({ asset }) {
    if (asset.thumbnail) return <BgImage src={asset.thumbnail} />
    return <BgIcon>
        <i className="far fa-file-video" aria-hidden="true" />
    </BgIcon>
}

function canPreview (asset) {
    return asset.type === 'video' && asset.fileUrl
}

function ButtonIcon (props) {
    return <button {...props}
        className={combineClasses('inv-btn-icon', props)}
    >
        {props.children}
    </button>
}

function StatusIcon ({ asset }) {
    var status = asset.currentStatus
    var { type } = asset
    var icon
    if (type === 'upload') {
        icon = <i className="fa fa-circle-notch fa-spin fa-fw" />
    } else if (status === 'archive') {
        icon = <i className="fa fa-archive" aria-hidden="true" />
    } else if (status === 'available') {
        icon = <i className="fa fa-check-circle" aria-hidden="true" />
    }

    var cssClass = 'misc-asset-status-icon ' + status

    return <Tippy content={toUpperCase(status)}>
        <span className={cssClass}>{icon}</span>
    </Tippy>
}

function toUpperCase (str) {
    return str ?
        str[0].toUpperCase().concat(str.slice(1)) :
        str
}

function Card (props) {
    return <div className={combineClasses('inv-card', props)}>
        {props.children}
    </div>
}

Card.Body = function (props) {
    return <div className={combineClasses('inv-card-body', props)}>
        {props.children}
    </div>
}

Card.Title = function (props) {
    return <div className={combineClasses('inv-card-title', props)}>
        {props.children}
    </div>
}

Card.Detail = function (props) {
    return <div className={combineClasses('inv-card-detail', props)}>
        {props.children}
    </div>
}

Card.Text = function (props) {
    return <div className={combineClasses('inv-card-text', props)}>
        {props.children}
    </div>
}

Card.Actions = function (props) {
    return <div className={combineClasses('inv-card-actions', props)}>
        {props.children}
    </div>
}

Card.Media = function (props) {
    return <div className={combineClasses('inv-card-media', props)}>
        {props.children}
    </div>
}

function combineClasses (_class, props) {
    return ((_class + ' ') + (props.className || '')).trim()
}

